import { ref } from 'vue';
import { useEndpoint } from './useEndpoint';
import { useUtilities } from './useUtilities';
import { IndustrySchema } from '@apparatix/schemas/AccountDetail';
import { IndustryCodeResponse } from '@apparatix/types/Account';

export const useIndustryCodes = () => {
  const industryCodes = ref<Array<Required<IndustrySchema>>>([]);
  const industryCodeRequired = ref(false);
  const placeholder = ref('Loading...');

  const { arrayHasValues } = useUtilities();

  const { isLoading, makeRequest } = useEndpoint<IndustryCodeResponse>({
    url: '/crm/accounts/industrycodeslegacy',
    type: 'GET',
    successField: 'data',
    startInLoadingState: true,
    onSuccess: response => {
      if (arrayHasValues(response.data.industryCodes)) {
        industryCodes.value = response.data.industryCodes satisfies IndustrySchema[];
        placeholder.value = 'Select Industry';
      } else {
        placeholder.value = 'Error loading Industry Codes';
      }

      industryCodeRequired.value = response.data.options?.isSicCodeRequired ?? false;
    },
    onError: () => {
      placeholder.value = 'Error loading Industry Codes';
    },
    toast: {
      showOnSuccess: false,
    },
  });

  makeRequest();

  return {
    industryCodeRequired,
    industryCodes,
    isLoading,
    placeholder,
  };
};
